module.exports = __webpack_public_path__ + "static/media/trash-restore.2d40b2db.svg";